// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_og-0";